module.exports = __webpack_public_path__ + "img/sleeping.2f51edd8.png";